<button (click)="toggleApprovement(true)"
        [disabled]="employees?.length === 0 || (overview && isEmployeeApproval && !overview.is_approvable_by_employee)"
        class="btn btn-light"
        id="attendance-approvement-button"
        style="min-width: 0 !important; padding-left: 12px !important; padding-right: 12px !important;"
        title="{{ 'employees_datetimes.action_approve' | translate }}"
        type="button">
  <span>{{ 'employees_datetimes.action_approve' | translate }}</span>
  <span *ngIf="employees?.length > 1"> ({{ employees.length }})</span>
</button>
